import Vue from 'vue'
import { Search, Form, Field, Lazyload, Swipe, SwipeItem, Image as VanImage, DatetimePicker, Popup, RadioGroup, Radio, Checkbox, CheckboxGroup, Button, Toast, Picker, Overlay, ActionSheet, Uploader, List, Loading, Area, Icon, Dialog, SwipeCell, NoticeBar } from 'vant'

Vue.use(Form)
Vue.use(Field)
Vue.use(Lazyload)
Vue.use(Swipe)
Vue.use(SwipeItem)
Vue.use(VanImage)
Vue.use(DatetimePicker)
Vue.use(Popup)
Vue.use(RadioGroup)
Vue.use(Radio)
Vue.use(CheckboxGroup)
Vue.use(Checkbox)
Vue.use(Button)
Vue.use(Toast)
Vue.use(Picker)
Vue.use(Overlay)
Vue.use(ActionSheet)
Vue.use(Uploader)
Vue.use(List)
Vue.use(Loading)
Vue.use(Area)
Vue.use(Icon)
Vue.use(Dialog)
Vue.use(Search)
Vue.use(SwipeCell)
Vue.use(NoticeBar)
